export const getQueryString = function () {
  const str = window.location.href.split('?')[1]
  let res = {}

  if (str) {
    str.split('&').forEach(item => {
      const [key, value] = item.split('=')

      res[key] = value
    })
  }

  return res
}

/*
* 函数防抖
*
* @activeUrl {String} 路由地址字符串
* @return    {String} 能匹配当前路由的url集合，包括子路由
*
*/

export const getMathUrlCollection = function (activeUrl) {
  if (activeUrl === '/') return ['/']

  const activeUrlCollections = activeUrl.split('/').filter(subPath => subPath)
  let mathUrlCollections = []
  let s = ''

  for (const subPath of activeUrlCollections) {
    mathUrlCollections.push(s += `/${subPath}`)
  }

  mathUrlCollections = mathUrlCollections.concat(mathUrlCollections.map(url => url.slice(1, url.length)))

  return mathUrlCollections
}